// extracted by mini-css-extract-plugin
export default {"root":"MultiConversationsPanel_root__3ZESs","fixedWidth":"MultiConversationsPanel_fixedWidth__ycE6k"};